//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as commonModule } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { IUserSession, UserSession, ConfigHelper, LocalizationHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services/services.module'
import { SYSTEM_SERVICE_NAME, SYSTEM_SERVICE_PROVIDER_NAME, SystemService, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $Q_SERVICE_NAME, $STATE_SERVICE_PROVIDER_NAME } from '../../services/system'
import { USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'
import { DataTypeGroupService, DATA_TYPE_GROUP_SERVICE_NAME } from '../../services/data-type-group'

import { DataTypeGroupsController } from './data-type-groups.controller'
import { DataTypeGroupDetailsDirective } from './details/data-type-group-details.directive'
import { DataTypeGroupCreateEditDirective } from './create-edit/data-type-group-create-edit.directive'
import { GridService, GRID_SERVICE_NAME } from '../../services/grid'
import { PecGliwiceDataTypeGroupCreateEditPopupDirective } from './data-type-group-configuration-form-pec-gliwice/pec-gliwice-create-edit-popup/pec-gliwice-create-edit-popup.directive'
import { PecGliwiceDataTypeGroupCreateEditDirective } from './data-type-group-configuration-form-pec-gliwice/pec-gliwice-create-edit/pec-gliwice-create-edit.directive'

//#region Asset Imports

import * as TEMPLATE from './data-type-groups.tpl.html'
import './data-type-groups.scss'

//#endregion

// Consts

const CONTROLER_NAME: string = 'DataTypeGroupController'
const DETAILS_DIRECTIVE_NAME: string = 'datatypeGroupDetails'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'datatypeGroupCreateEdit'
const PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_DIRECTIVE_NAME: string = 'datatypeGroupCreateEditPecGliwice'
const PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_POPUP_DIRECTIVE_NAME: string = 'datatypeGroupCreateEditPecGliwicePopup'
const MODULE_NAME: string = 'simax.dataTypeGroups'
const MODULE_NAME_LOCALIZATION_TEXT: string = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__NAME, Enums.SimaxModuleName.Datatype_Group)
const MENU_INDEX: number = 20
const STATE_NAME: string = 'dataTypeGroups'
const STATE_URL: string = '/datatypegroups'

// Consts End

// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    $Q_SERVICE_NAME,
    'api',
    'localDictionary',
    SYSTEM_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    DATA_TYPE_GROUP_SERVICE_NAME,
    GRID_SERVICE_NAME,
    (
        $scope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        $q: ng.IQService,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        systemService: SystemService,
        userSession: IUserSession,
        dataTypeGroupService: DataTypeGroupService,
        gridservice: GridService
    ) => new DataTypeGroupsController(
        $scope,
        $state,
        $timeout,
        $q,
        api,
        localDictionary,
        systemService,
        userSession,
        dataTypeGroupService,
        gridservice,
        DataTypeGroupService.REFERENCE_TYPE,
        DataTypeGroupService.SIMAX_MODULE_NAME
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new DataTypeGroupDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new DataTypeGroupCreateEditDirective()])

module.directive(PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_DIRECTIVE_NAME, [() => new PecGliwiceDataTypeGroupCreateEditDirective()])
module.directive(PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_POPUP_DIRECTIVE_NAME, [() => new PecGliwiceDataTypeGroupCreateEditPopupDirective()])

module.config(
    [
        $STATE_SERVICE_PROVIDER_NAME,
        USER_SESSION_SERVICE_PROVIDER_NAME,
        SYSTEM_SERVICE_PROVIDER_NAME,
        (
            $stateProvider: StateProvider,
            userSessionProvider: UserSession,
            systemServiceProvider: SystemServiceProvider
        ) => {

            userSessionProvider.getLoggedOperatorAsync()
                .then((loggedOperator: OpOperator) => {
                    if (loggedOperator.hasPermission(Activity.DATA_TYPE_GROUP_LIST)
                        && !loggedOperator.hasPermission(Activity.DATA_TYPE_GROUP_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DataTypeGroupModule)) {

                        systemServiceProvider.registerDetailsComponent({
                            key: 'Datatype_Group_IdDataTypeGroup',
                            componentName: DETAILS_DIRECTIVE_NAME
                        })

                        MenuItem.addMenuItem(
                            ConfigHelper.getIconName(ConfigHelper.Icon.DESCRIPTION),
                            'dataTypeGroups',
                            MODULE_NAME_LOCALIZATION_TEXT,
                            STATE_NAME,
                            MENU_INDEX
                        )

                        $stateProvider.state(STATE_NAME, {
                            url: STATE_URL,
                            controller: CONTROLER_NAME,
                            template: TEMPLATE,
                            params: { ids: null }
                        })
                    }
                })
        }])

// Setup End

export default MODULE_NAME